// src/pages/AdminSetting.js

import React,
{
  useEffect,
  useState,
} from "react";

import {
  FiShield,
  FiCheck,
  FiX,
  FiRefreshCw,
} from "react-icons/fi";

import {
  FaUserShield,
} from "react-icons/fa";

import Swal from "sweetalert2";

import {
  getData,
  postData,
} from "../../../services/FetchNodeservices";

export default function AdminSetting() {

  // =================================================
  // STATES
  // =================================================

  const [data,
    setData] =
    useState([]);

  const [loading,
    setLoading] =
    useState(true);

  // =================================================
  // PERMISSIONS
  // =================================================

  const permissions = [

    "can_post_job",

    "can_assign_task",

    "can_update_candidate",

    "can_add_closure",

    "can_manage_interview",

    "can_manage_joining",

    "can_manage_vendor",

    "can_view_reports",

    "can_manage_users",

    "can_manage_hierarchy",

    "full_access",
  ];

  // =================================================
  // LOAD DATA
  // =================================================

  const loadData =
    async () => {

      try {

        setLoading(true);

        const result =
          await getData(
            "permission/fetch"
          );

        console.log(
          "Permission API:",
          result
        );

        if (
          result &&
          result.status
        ) {

          setData(
            Array.isArray(
              result.data
            )
              ? result.data
              : []
          );

        } else {

          setData([]);
        }

      } catch (err) {

        console.log(
          "Permission Error:",
          err
        );

        setData([]);

      } finally {

        setLoading(false);
      }
    };

  useEffect(() => {

    loadData();

  }, []);

  // =================================================
  // TOGGLE
  // =================================================

  const togglePermission =
    async (
      row,
      field
    ) => {

      try {

        const payload = {

          ...row,

          [field]:
            row[field] === 1
              ? 0
              : 1,
        };

        const result =
          await postData(

            `permission/update/${row.id}`,

            payload
          );

        if (
          result?.status
        ) {

          Swal.fire({

            icon:
              "success",

            title:
              "Updated",

            timer:
              1000,

            showConfirmButton:
              false,
          });

          loadData();

        } else {

          Swal.fire({

            icon:
              "error",

            title:
              result.message ||
              "Update Failed",
          });
        }

      } catch (err) {

        console.log(err);

        Swal.fire({

          icon:
            "error",

          title:
            "Something went wrong",
        });
      }
    };

  // =================================================
  // UI
  // =================================================

  return (

    <div
      className="
        min-h-screen
        bg-[#f6f8fb]
        md:ml-72
        mt-14
        p-6
      "
    >

      {/* HEADER */}

      <div
        className="
          flex
          items-center
          justify-between
          mb-6
        "
      >

        <div>

          <h1
            className="
              text-2xl
              font-semibold
              flex
              items-center
              gap-3
            "
          >

            <div
              className="
                w-11
                h-11
                rounded-2xl
                bg-black
                text-white
                flex
                items-center
                justify-center
              "
            >
              <FaUserShield />
            </div>

            Admin Settings
          </h1>

          <p
            className="
              text-sm
              text-gray-500
              mt-2
            "
          >
            Role Based Permission Control
          </p>
        </div>

        <button
          onClick={
            loadData
          }
          className="
            bg-white
            border
            border-gray-200
            px-4
            py-3
            rounded-2xl
            flex
            items-center
            gap-2
          "
        >

          <FiRefreshCw />

          Refresh
        </button>
      </div>

      {/* LOADING */}

      {loading ? (

        <div
          className="
            bg-white
            rounded-3xl
            p-10
            text-center
          "
        >
          Loading...
        </div>

      ) : data.length === 0 ? (

        <div
          className="
            bg-white
            rounded-3xl
            p-10
            text-center
            text-gray-500
          "
        >
          No Permission Data Found
        </div>

      ) : (

        <div
          className="
            grid
            grid-cols-1
            xl:grid-cols-2
            gap-6
          "
        >

          {data.map(
            (role,
              index) => (

              <div
                key={index}
                className="
                  bg-white
                  rounded-3xl
                  border
                  border-gray-200
                  overflow-hidden
                  shadow-sm
                "
              >

                {/* TOP */}

                <div
                  className="
                    p-5
                    border-b
                    border-gray-100
                  "
                >

                  <h2
                    className="
                      text-lg
                      font-semibold
                    "
                  >
                    {
                      role.designation_name
                    }
                  </h2>

                  <p
                    className="
                      text-xs
                      text-gray-500
                      mt-1
                    "
                  >
                    Manage Permissions
                  </p>
                </div>

                {/* BODY */}

                <div className="p-5">

                  <div
                    className="
                      grid
                      grid-cols-2
                      gap-4
                    "
                  >

                    {permissions.map(
                      (
                        permission
                      ) => (

                        <div
                          key={
                            permission
                          }
                          className="
                            border
                            border-gray-100
                            rounded-2xl
                            p-4
                            flex
                            items-center
                            justify-between
                          "
                        >

                          <div>

                            <h3
                              className="
                                text-sm
                                font-medium
                              "
                            >
                              {permission
                                .replaceAll(
                                  "_",
                                  " "
                                )
                                .toUpperCase()}
                            </h3>
                          </div>

                          <button
                            onClick={() =>
                              togglePermission(

                                role,

                                permission
                              )
                            }
                            className={`

                              w-12
                              h-7
                              rounded-full
                              flex
                              items-center
                              px-1
                              transition-all

                              ${
                                role[
                                  permission
                                ] === 1

                                  ? "bg-black justify-end"

                                  : "bg-gray-300 justify-start"
                              }

                            `}
                          >

                            <div
                              className="
                                w-5
                                h-5
                                rounded-full
                                bg-white
                                flex
                                items-center
                                justify-center
                              "
                            >

                              {role[
                                permission
                              ] === 1 ? (

                                <FiCheck
                                  size={11}
                                />

                              ) : (

                                <FiX
                                  size={11}
                                />
                              )}
                            </div>
                          </button>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
}